<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">Hi~ <a class="font3">{{ ReportData.stuname }}</a>，我们又见面啦</p>
        <p  class="font1" style="padding-top: 1vh;">勤学不辍，硕果累累</p>
        <!-- 有学习天数，有学习时长 -->
        <div>
            <p  class="font1" style="padding-top: 1.5vh;">学习是对自己最好的投资</p>
            <p  class="font1" style="padding-top: 1.5vh;">新的一年，让你的时间更有价值！</p>
            <!-- <p class="font1">你在富学宝典平台上学习了<a class="font3">{{ ReportData.studate }}</a>天</p>
            <p class="font1" v-if="ReportData.playtime !==0">累计学习了<a class="font3">{{ ReportData.playtime }}</a>小时</p> -->
            <!-- <p  class="font1" style="padding-top: 4vh;">每一天的学习都是你进步的见证</p>
            <p class="font1">每一个刻苦学习的瞬间都是未来成功的基石</p> -->
            <div style="padding-top: 6vh;text-align: center;">
                <p style="margin: 0;">继续保持这份热情</p>
                <p style="margin: 0;">你的梦想终将实现</p>
            </div>
            <p style="padding-top: 3vh;text-align: center;">左滑查看专属于你的一月学习报告吧</p>
        </div>
    </div>
</template>
  
<script>

export default {
    props: [ "ReportData"],
}
</script>
  
<style scoped>       
.body {
    background:
                url("../../assets/logo1.png") right  top  no-repeat,
                url("../../assets/25January/icon.png") 49% calc(100% + 30px) no-repeat,
                url("../../assets/25January/bg.jpg")  no-repeat;
    background-size: 110px 35px, 68%,cover;
    width: 100%;
    height: 100vh;
}

.font1 {
    width: 92%;
    padding-left: 8%;
    margin: 0;
    text-align: left;
    font-size: 18px;
    color: #000;
    /* font-weight: bold; */
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    color: #000;
    font-size: 15px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: #fad3a2;
    /* text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff; */
    /* font-weight: bolder; */
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>